export const Footer = () => {
  return (
    <footer>
      <div className="footer">
        <div className="footer__line">
          <div className="footer__inner">
            <div className="footer__copy">powered by Bitkey Inc.</div>
          </div>
        </div>
      </div>
    </footer>
  );
};
